/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconCalendar(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.877.146c.284.059.497.31.497.61v.362h.752l.192.01A1.875 1.875 0 0 1 16 2.99v11.075l-.01.181v.008c-.102.97-.937 1.612-1.864 1.612H1.874c-.927 0-1.762-.641-1.863-1.61L0 14.06V2.991c0-1.034.84-1.873 1.874-1.873h.752V.757c0-.344.279-.624.623-.624l.125.013c.284.059.498.31.499.61v.362h8.254V.757c0-.344.28-.624.624-.624zM1.247 14.06l.01.112c.052.253.278.449.617.45h12.252c.386-.001.623-.255.626-.558V6.006H1.247zm.627-11.694a.627.627 0 0 0-.627.626V4.76h13.505V2.991l-.013-.126a.63.63 0 0 0-.487-.487l-.126-.013h-.752v.892c0 .3-.213.552-.497.61l-.126.014a.625.625 0 0 1-.624-.624v-.892H3.873v.892a.625.625 0 0 1-.499.61l-.125.014a.624.624 0 0 1-.623-.624v-.892z"
        clipRule="evenodd"
      />
    </svg>
  );
}
